import '../../../../../types/product.js';
import { isSubscriptionPurchase } from '../../../../../types/typeguards.js';
import { getSelectors } from '../selectors.js';

const { isOneColConfigurator , getEnabledSelectedQuantity  } = getSelectors();
const hasNullValues = (config)=>Object.values(config).some((value)=>value === null
    )
;
const isColumnValid = (columnState, columnConfigurations)=>{
    if (!columnState.isEnabled) {
        return true;
    }
    if (!hasNullValues(columnConfigurations.prescription)) {
        return true;
    }
    return false;
};
/**
 * The Columns are valid when at least one column is enabled
 * and all enabled columns are completely filled in.
 */ const areColumnsValid = (state)=>{
    if (isOneColConfigurator(state)) {
        return isColumnValid(state.configurator.both, state.configurations.both);
    }
    const isLeftValid = isColumnValid(state.configurator.left, state.configurations.left);
    const isRightValid = isColumnValid(state.configurator.right, state.configurations.right);
    return isLeftValid && isRightValid;
};
const areColumnCheckboxesValid = (state)=>{
    if (isOneColConfigurator(state)) {
        // If there is only one column, the checkboxes are not shown. Consider them always valid
        return true;
    }
    return state.configurator.left.isEnabled || state.configurator.right.isEnabled;
};
const isDeliveryIntervalValid = ({ configurations  })=>{
    const { purchaseType , subscriptionPurchaseConfigurations  } = configurations;
    if (isSubscriptionPurchase(purchaseType)) {
        return subscriptionPurchaseConfigurations.deliveryInterval !== null;
    }
    return undefined;
};
const isQuantityValid = (selectedQuantity, maxSelectableQuantity)=>selectedQuantity <= maxSelectableQuantity
;
const isConfiguratorValid = (state)=>{
    const { columnCheckboxes , columns , deliveryInterval  } = state.configurator;
    const hasInvalid = [
        columnCheckboxes.areValid,
        columns.areValid,
        deliveryInterval.isValid
    ].some((value)=>value === false
    );
    return !hasInvalid;
};
const getNewQuantity = (newQuantity, maxQuantity)=>{
    return newQuantity > maxQuantity ? maxQuantity : newQuantity;
};
const splitTotalQuantityBetweenEyesides = (state, newTotalQuantity)=>{
    const currentTotalQuantity = getEnabledSelectedQuantity(state);
    const maxSelectableBothQuantity = state.configurator.both.quantitySelector.maxSelectableQuantity;
    const maxSelectableLeftQuantity = state.configurator.left.quantitySelector.maxSelectableQuantity;
    const maxSelectableRightQuantity = state.configurator.right.quantitySelector.maxSelectableQuantity;
    const newBothQuantity = getNewQuantity(newTotalQuantity, maxSelectableBothQuantity);
    // All columns are disabled, so do not update the quantities
    if (!currentTotalQuantity) {
        return {
            leftQuantity: state.configurations.left.quantity,
            rightQuantity: state.configurations.right.quantity,
            bothQuantity: state.configurations.both.quantity
        };
    }
    if (state.configurator.left.isEnabled && !state.configurator.right.isEnabled) {
        return {
            leftQuantity: getNewQuantity(newTotalQuantity, maxSelectableLeftQuantity),
            rightQuantity: state.configurations.right.quantity,
            bothQuantity: newBothQuantity
        };
    }
    if (!state.configurator.left.isEnabled && state.configurator.right.isEnabled) {
        return {
            leftQuantity: state.configurations.left.quantity,
            rightQuantity: getNewQuantity(newTotalQuantity, maxSelectableRightQuantity),
            bothQuantity: newBothQuantity
        };
    }
    /**
   * If both eyesides are enabled, split the quantity in half.
   * If the added quantity is uneven, the right side gets the extra one.
   */ return {
        leftQuantity: getNewQuantity(Math.floor(newTotalQuantity / 2), maxSelectableLeftQuantity),
        rightQuantity: getNewQuantity(Math.ceil(newTotalQuantity / 2), maxSelectableRightQuantity),
        bothQuantity: newBothQuantity
    };
};

export { areColumnCheckboxesValid, areColumnsValid, isColumnValid, isConfiguratorValid, isDeliveryIntervalValid, isQuantityValid, splitTotalQuantityBetweenEyesides };
//# sourceMappingURL=state-helpers.js.map
